<template>
  <K2Row flex_direction="column" justify_content="center" align="center">
    <img src="../../assets/notif1.png" style="margin: 0 auto; height: 120px" />
    <K2Text bold="true" :font-size="uiVariable.fontSize.lg">No result found</K2Text>
    <K2Text>Please try again later</K2Text>
  </K2Row>
</template>
<script>
import K2Row from '../k2Row/k2Row'
import K2Text from '../k2Text/k2Text'
import uiVariable from '../../config/uiVariable'

export default {
  name: 'K2Empty',
  components: { K2Text, K2Row },
  data() {
    return {
      uiVariable: uiVariable,
    }
  },
}
</script>
